import { liveMatches } from '@/mocks/homeData';

export default function LiveMatchesSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse"></span>
              <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase">LIVE</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              正在直播的赛事
            </h2>
          </div>
          <a
            href="/category/sports"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部赛事 <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {liveMatches.map((match) => (
            <a
              key={match.id}
              href={`/category/${match.id}`}
              className="group relative bg-background-50 border border-background-200 rounded-xl p-4 md:p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1.5">
                  <i className={`${match.leagueIcon} text-xs text-foreground-500`}></i>
                  <span className="text-xs text-foreground-500">{match.league}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                  </span>
                  <span className="text-xs font-semibold text-red-500">{match.time}</span>
                </div>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="flex-1 text-center">
                  <p className="text-sm font-bold text-foreground-900 mb-1">{match.homeTeam}</p>
                </div>
                <div className="flex items-center gap-2 px-4">
                  <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    {match.homeScore}
                  </span>
                  <span className="text-sm text-foreground-400">-</span>
                  <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    {match.awayScore}
                  </span>
                </div>
                <div className="flex-1 text-center">
                  <p className="text-sm font-bold text-foreground-900 mb-1">{match.awayTeam}</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                {'home' in match.odds ? (
                  <>
                    <button className="flex-1 py-2 rounded-lg bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors text-center cursor-pointer">
                      <span className="block text-xs text-foreground-500 mb-0.5">主胜</span>
                      <span className="block text-sm font-bold text-foreground-800">{match.odds.home}</span>
                    </button>
                    <button className="flex-1 py-2 rounded-lg bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors text-center cursor-pointer">
                      <span className="block text-xs text-foreground-500 mb-0.5">平局</span>
                      <span className="block text-sm font-bold text-foreground-800">{match.odds.draw}</span>
                    </button>
                    <button className="flex-1 py-2 rounded-lg bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors text-center cursor-pointer">
                      <span className="block text-xs text-foreground-500 mb-0.5">客胜</span>
                      <span className="block text-sm font-bold text-foreground-800">{match.odds.away}</span>
                    </button>
                  </>
                ) : (
                  <>
                    <button className="flex-1 py-2 rounded-lg bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors text-center cursor-pointer">
                      <span className="block text-xs text-foreground-500 mb-0.5">{match.homeTeam}</span>
                      <span className="block text-sm font-bold text-foreground-800">{match.odds.home}</span>
                    </button>
                    <button className="flex-1 py-2 rounded-lg bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors text-center cursor-pointer">
                      <span className="block text-xs text-foreground-500 mb-0.5">{match.awayTeam}</span>
                      <span className="block text-sm font-bold text-foreground-800">{match.odds.away}</span>
                    </button>
                  </>
                )}
              </div>

              <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200">
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>{match.viewers} 观看
                </span>
                <span className="text-xs text-accent-600 font-medium cursor-pointer">
                  进入竞猜 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}